import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Moment from "react-moment";
import { toast } from "react-toastify";
import moment from "moment";
import ResultDetails from "./resultDetails";
import { cloneDeep } from "lodash";
// import { useLinkComponentDataWithNoteMutation } from "app/redux/providerNoteService";
import baseApiHelper from "../../services/baseApiHelper";
// import { Icon } from "../../helpers/icons";
import MainPageDialog from "../../components/dialog";
import ActionMenuList from "../../components/ActionMenuList";
import { useGetRadiologyAcknowledgeMutation, useGetRadiologyFileUidResultMutation } from "../../services/radiologyService";
import { PdfViewer } from "../../components/pdfViewer";
import ActionDialog from "../../components/actionDialog";
import { Icon } from "../../helpers/icons";

const RadiologyResultListing = (prop) => {
  const {resultList, from, openResultForm ,shareDataDetail,selectedChat}=prop
  const [resultData,setResultData]=useState([])
  const [allSelected, setSelectedAll] = useState(false);
  const [orderCollapse, setOrderCollapse] = useState({});
  const [pdfViewerData, setPdfViewerData] = useState({});
  const [dataLoadingId, setDataLoadingId] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState({
    show: false,
    title: "",
    from: "",
  });

  useEffect(()=>{
    if (resultList?.length>0){
      setResultData(resultList)
    }
  },[resultList])
  const {
    // practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  // const { selectedNote, authToken } = useSelector(
  //   ({ auth, providerNote }) => ({
  //     selectedNote: providerNote.selectedNote,
  //     authToken: auth && auth.authToken,
  //   }),
  //   shallowEqual
  // );

  const toggleLabOrder = (lab_id) => {
    const val = orderCollapse[lab_id] ? false : true;
    setOrderCollapse({ ...orderCollapse, [lab_id]: val });
  };

  
  const [fileUid] = useGetRadiologyFileUidResultMutation();

  const printPdfOrder = async (item) => {
    let title = "Order #: " + item.order_number;

    const res = await fileUid({ radiology_id: item.id });
    setDataLoadingId(null);
    if (res.data) {
      let response = { ...res.data };
      response.pid = selectedChat?.pid;
      if (response.file_name) {
        title = response.file_name;
      }
      previewPdfOrder(response, title);
    }
  };

  const previewPdfOrder = (data, title) => {
    const pdfData = { ...data, title };

    //this url only works for pdfs
    if (data.file_id) {
      pdfData.previewPdfUrl = `${
        process.env.REACT_APP_API_URL_V1
      }/efax/read_document?file_name=${
        data.file_id
      }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;
    } else {
      pdfData.previewPdfUrl = `${
        process.env.REACT_APP_API_URL_V1
      }/efax/read_document?file_name=${
        data.file_uuid
      }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;
    }

    setPdfViewerData({ isOpen: true, pdfData });
  };

  const getActionBts = (item) => {
    let buttons = [
      {
        label: "Print",
        onClick: () => {
          printPdfOrder(item);
          setDataLoadingId(item.id);
        },
      },
    ];

    if (item.can_save_results) {
      buttons.push({
        label: "Edit Result",
        onClick: () => {
          openResultForm(item, true);
        },
      });
    }

    if (!item.acknowledged) {
      buttons.push({
        label: "Acknowledged",
        onClick: () => {
          setConfirmationModal({
            show: true,
            title: "Are you sure you want to Acknowledge?",
            from: "acknowledged",
            item,
          });
          setDataLoadingId(item.id);
        },
      });
    }

    // if (!item.linked_encounter?.includes(selectedNote.encounter)) {
    //   buttons.push({
    //     label: "Add to Note",
    //     onClick: () => {
    //       linkResultWithNote(item);
    //     },
    //   });
    // }

    // if (
    //   item.linked_encounter?.includes(selectedNote.encounter) &&
    //   from !== "results"
    // ) {
    //   buttons.push({
    //     label: "Remove from Note",
    //     onClick: () => {
    //       linkResultWithNote(item, true);
    //     },
    //   });
    // }

    return buttons;
  };

  const onCancelConfirmationModal = () => {
    setConfirmationModal({ show: false, title: "", from: "" });
    setDataLoadingId(null);
  };

  const [acknowledgeSave] = useGetRadiologyAcknowledgeMutation();

  const onConfirmHandler = () => {
    if (confirmationModal.from == "acknowledged") {
      acknowledgeSave({
        pid: selectedNote?.pid,
        id: confirmationModal.item?.id,
      }).then((res) => {
        if (res?.data?.response?.code == 0) {
          toast.success("Radiology results are acknowledged!");
        }
      });
    }
    onCancelConfirmationModal();
  };

  const formatOrderDate = (dateTime) => {
    if (dateTime) {
      return moment(dateTime).format("MM/DD/YYYY hh:mm A");
    }
  };

  // const [linkComponentDataWithNote] = useLinkComponentDataWithNoteMutation();

  // const linkResultWithNote = (item, isRemoveFromNote) => {
  //   let activeData = [];
  //   if (selectedNote?.clinical_data?.radiology) {
  //     activeData = cloneDeep(selectedNote?.clinical_data?.radiology);
  //     activeData = activeData.split(",");
  //   }

  //   if (isRemoveFromNote) {
  //     const foundOrderIndex = activeData.indexOf(item?.id);
  //     if (foundOrderIndex > -1) {
  //       activeData.splice(foundOrderIndex, 1);
  //     }
  //   } else {
  //     activeData.push(item?.id);
  //   }

  //   activeData = activeData.join(",");

  //   let data = {
  //     active: activeData,
  //     extracted: [],
  //     slug: "radiology",
  //     note: { ...selectedNote },
  //   };

  //   setDataLoadingId(item?.id);
  //   linkComponentDataWithNote(data).then((res) => {
  //     setDataLoadingId(null);
  //     if (res?.data?.response?.code == 0) {
  //       toast.success(res?.data?.response?.msg);
  //       baseApiHelper().invalidateTags(["Radiologyresult"]);
  //     } else if (res?.data?.response?.msg) {
  //       toast.error(res?.data?.response?.msg);
  //     }
  //   });
  // };

  const triggerPrint = ()=>{
    window.open(pdfViewerData.pdfData.previewPdfUrl, '_blank');
    setPdfViewerData({});
  }
  const toggleSelectItem = (item, itemIndex, e) => {
      const selected = e.target.checked;
      let modifyResultData=[...resultData]
      let modifyItem={...item}
      modifyItem.selected = selected;
      modifyResultData[itemIndex] = modifyItem;
      setResultData([...modifyResultData]);
      const unselected = modifyResultData?.find((item) => {
        return !item?.selected;
      });
      const all = unselected ? false : true;
      setSelectedAll(all);
      console.log(prop,"prop")
      if (prop?.toggleSelectItem) {
        const selectedItems = modifyResultData?.filter((item) => item?.selected);
        prop?.toggleSelectItem(selectedItems);
      }
  };
  const toggleSelectAll = (e) => {
    const checkedAll = e.target.checked;
    let modifyResultData=[...resultData]?.map((item) => {
        return({...item,selected:checkedAll})
    });
    setResultData([...modifyResultData])
    setSelectedAll(checkedAll);
    if (prop?.toggleSelectAll) {
      prop?.toggleSelectAll(e);
    }
    console.log(prop,"prop")

    const selectedItems = checkedAll ? resultData : [];
    if (prop?.toggleSelectItem) {
      prop?.toggleSelectItem(selectedItems);
    }
    if (prop?.toggleSelectItem) {
      prop?.toggleSelectItem(selectedItems);
    }
  };
  const pdfPreviewFooterList = [
    { type: 'cancel', action: () => setPdfViewerData({}), title: 'Cancel' },
    { type: 'save', action: () => triggerPrint(), title: 'Print' },
  ]

  return (
    <>
      <div className="flex p-1 gap-x-2 border-l-4 bg-gray-c-150 border-left-teal-c-100-20 justify-center items-center">
        <input
          type="checkbox"
          onChange={(e) => {
            toggleSelectAll(e);
          }}
          checked={allSelected}
        />
        <p className="w-2/12">Order Number</p>
        <p className="w-2/12">Radiology Practice</p>
        <p className="w-2/12">Provider</p>
        <p className="w-2/12">Assigned To</p>
        <p className="w-1/12">Date</p>
        <p className="w-1/12">Status</p>
        <p className="w-1/12">Actions</p>
      </div>
      <div className="divide-y divide-gray-200 bg-white alternative-color border-l-4 border-r">
        {!resultData || resultData?.length == 0 ? (
          <div className="flex flex-row justify-between items-center box-shadow py-1.5 px-2.5">
            <div className="text-center w-full">No record found.</div>
          </div>
        ) : null}

        {resultData?.map((result, index) => {
          return (
            <div key={index}>
              <div className="flex border-b-2 p-1 gap-x-2 justify-center items-center font-light">
                <div className='w-1/13'>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    toggleSelectItem(result, index, e);
                  }}
                   checked={result?.selected}
                />
                </div>
                <p className="flex w-2/12 pl-2 gap-x-2">
                  <button onClick={() => toggleLabOrder(result.id)}>
                    <Icon
                      type={
                        !orderCollapse[result.id]
                          ? "arrow_forward"
                          : "arrow_down"
                      }
                    />
                  </button>
                  <p>{result.order_number}</p>
                </p>
                <p className="w-2/12">
                  {result.radiology_practice_name
                    ? result.radiology_practice_name
                    : "-"}
                </p>
                <p className="w-2/12">
                  {result.ordering_provider_name
                    ? result.ordering_provider_name
                    : "-"}
                </p>
                <p className="w-2/12 capitalize">
                  {result?.assigned_to_name ? result?.assigned_to_name : "-"}
                </p>
                <p
                  className="w-1/12 flex gap-1"
                  title={formatOrderDate(result.datetime)}
                >
                  <Moment format="MM/DD/YYYY">
                    {result.datetime ? result.datetime : "-"}
                  </Moment>
                </p>
                <p className="w-1/12">
                  {result?.result_status_text == "Draft" ? (
                    <span className="bg-yellow-100 rounded p-1">
                      {result?.result_status_text}
                    </span>
                  ) : (
                    <span className="bg-green-200 rounded p-1">
                      {result?.result_status_text}
                    </span>
                  )}
                </p>
                <p className="w-1/12 mr-1">
                  <ActionMenuList
                    title={
                      <>
                        {dataLoadingId == result?.id ? (
                          <Icon className="ml-1" size="7" type="loading-dots" />
                        ) : (
                          <>Actions</>
                        )}
                      </>
                    }
                    menuList={getActionBts(result)}
                  />
                </p>
              </div>
              {orderCollapse[result.id] ? (
                <div className="items-center p-2">
                  {result?.radiology_data?.map((test) => {
                    return <ResultDetails test={test} />;
                  })}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>

      {confirmationModal.show ? (
        <ActionDialog
          onCancelHandler={onCancelConfirmationModal}
          setShowModal={onCancelConfirmationModal}
          onConfirmHandler={onConfirmHandler}
          showModal={confirmationModal.show}
          title={confirmationModal.title}
        />
      ) : null}

      {pdfViewerData.isOpen ? (
        <MainPageDialog
          title={pdfViewerData.pdfData.title}
          onCancelHandler={() => {
            setPdfViewerData({});
          }}
          footer={true}
          footerList= {pdfPreviewFooterList}
        >
          <div>
            <PdfViewer data={pdfViewerData.pdfData} />
          </div>
        </MainPageDialog>
      ) : null}
    </>
  );
};

export default RadiologyResultListing;
